import React from 'react'

const Field = ({ label, required, badge, suggestion, onAcceptSuggestion, children }) => {
    return (
        <div className="field">
            <span className="field-label">
                {label} {required ? <span className="field-required">*</span> : null}
                {badge ? <span className="ai-badge">{badge}</span> : null}
            </span>
            {children}
            {suggestion ? (
                <span className="ai-suggestion">
                    <span className="ai-suggestion__text">{suggestion}</span>
                    {onAcceptSuggestion ? (
                        <button type="button" className="ai-suggestion__button" onClick={onAcceptSuggestion}>
                            Använd förslag
                        </button>
                    ) : null}
                </span>
            ) : null}
        </div>
    );
}

export default Field
